import { Card, CardActions, CardMedia, Grid, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RemoteFile } from './RemoteFile';

interface Props {
  photos: RemoteFile[];
  onDeletePhoto?: (photo: RemoteFile, index: number) => void;
}

const RemoteGallery = ({ photos, onDeletePhoto }: Props) => {
  const { t } = useTranslation('common');
  const xs = ((numberOfFiles: number) => {
    if (numberOfFiles === 1) return 12;
    else if (numberOfFiles === 2) return 6;
    else return 4;
  })(photos.length);
  const gridTemplateColumns = ((numberOfFiles: number) => {
    if (numberOfFiles === 1) return '1fr';
    else if (numberOfFiles === 2) return '1fr 1fr';
    else return '1fr 1fr 1fr';
  })(photos.length);
  return (
    <div
      className={`tw-justify-normal`}
      style={{ display: 'grid', gap: '0.75rem', gridTemplateColumns, gridAutoRows: '1fr' }}
    >
      {photos.map((photo, index) => (
        <Grid item xs={xs} key={`RemoteGallery.${index}`}>
          <Card className="tw-relative tw-h-full tw-flex tw-flex-col tw-justify-between" elevation={0}>
            <div className="tw-flex tw-flex-col tw-justify-center tw-h-full">
              <CardMedia className="tw-block" component="img" image={photo.signedUrl} />
            </div>
            {onDeletePhoto && (
              <CardActions
                disableSpacing
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  backgroundColor: { lg: '#F9F5F2' },
                  padding: 0,
                  paddingTop: '0.75rem',
                }}
              >
                <IconButton
                  sx={{
                    fontFamily: 'BentonSans',
                    color: '#B05F30',
                    fontWeight: 500,
                    backgroundColor: '#F3E8DF',
                    borderRadius: '99999px',
                    fontSize: 10,
                    textAlign: 'center',
                  }}
                  onClick={(e) => {
                    onDeletePhoto(photo, index);
                  }}
                >
                  <span className="tw-px-6 tw-inter">{t('remove').toUpperCase()}</span>
                </IconButton>
              </CardActions>
            )}
          </Card>
        </Grid>
      ))}
    </div>
  );
};

export default RemoteGallery;
